/**
 * Find all elements in a that are not in b and vice versa.
 * @param a
 * @param b
 */
export function getArrayDiff<T>(a: T[], b: T[]): T[] {
	const aNotInB = a.filter((x: T): boolean => !b.includes(x));
	const bNotInA = b.filter((x: T): boolean => !a.includes(x));
	return Array.from(new Set([...aNotInB, ...bNotInA]));
}
